/**
 * NVTUAN1 26.04.2023
 * Id báo cáo
 */
export default {
  //Id chung cho báo cáo Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP) mẫu ngang, mẫu dọc 
  BC_56_01_ND11_2020: '56_01_ND11_2020',
};
